import { Component, OnInit, inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AdminOverviewService } from '../..//services/admin-overview.service';
import { BreadcrumbService } from '../../services/breadcrumb.service';
import { TitleService } from '../../services/title.service';
import { BreadCrumbComponent } from '../breadcrumb/breadcrumb.component';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-admin-overview',
    templateUrl: './admin-overview.component.html',
    styleUrls: ['./admin-overview.component.scss'],
    imports: [BreadCrumbComponent, FormsModule]
})
export class AdminOverviewComponent implements OnInit {
  private titleService = inject(TitleService);
  private breadcrumbService = inject(BreadcrumbService);
  adminOverviewService = inject(AdminOverviewService);
  private toasterService = inject(ToastrService);


  settings: Record<string, unknown> = {};

  ngOnInit(): void {
    this.render();
  }

  render(): void {
    this.titleService.set('Admin Overview');
    this.breadcrumbService.set('Admin Overview');
    this.fetch();
  }

  async fetch(): Promise<void> {
    this.settings = await this.adminOverviewService.fetch();
  }

  saleOnHandler(_event: Event): void {
    this.saveSetting('saleOn', this.settings.saleOn);
  }

  salePercentHandler(_event: Event): void {
    this.saveSetting('salePercent', this.settings.salePercent);
  }

  saveSetting(name: string, value: unknown): void {
    this.adminOverviewService.saveSetting(name, value).subscribe(() => {
      this.toasterService.success('Setting saved.', 'Successful!');
    });
  }

}
